import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';

class MapDialog extends React.Component {
    handleClose = () => {
        this.props.onClose(this.props.selectedValue);
    };

    render() {
        const { ...other } = this.props;

        return (
            <Dialog fullWidth={true} maxWidth={'lg'} onClose={this.handleClose} aria-labelledby="simple-dialog-title" {...other}>
                <div style={{margin: "0 auto"}}>
                    <iframe
                        title={"map"}
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d27211.84923918512!2d-9.78005175727618!3d31.510942357837212!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xdad9a4e9f588ccf%3A0x57421a176d5d7d30!2sEssaouira%2C+Morocco!5e0!3m2!1sen!2suk!4v1554581457410!5m2!1sen!2suk"
                        width="800" height="800" frameBorder="0" style={{}} allowFullScreen/>
                </div>
            </Dialog>
        );
    }
}

MapDialog.propTypes = {
    onClose: PropTypes.func,
    selectedValue: PropTypes.string,
};

export default MapDialog;